import React, { useEffect } from "react";
import { COLORS, PERSONAL } from "./data/profile";
import { LanguageProvider, useLang } from "./LanguageContext";
import Hero from "./components/Hero";
import ImpactNumbers from "./components/ImpactNumbers";
import StorySection from "./components/StorySection";
import AiAtScaleSection from "./components/AiAtScaleSection";
import CapabilitiesSection from "./components/CapabilitiesSection";
import WhatIDo from "./components/WhatIDo";
import AIChatSection from "./components/AIChatSection";
import FitSection from "./components/FitSection";
import Credentials from "./components/Credentials";

function Footer() {
  const { lang } = useLang();
  return (
    <footer className="site-footer">
      <div className="section-inner" style={{ textAlign: "center" }}>
        <p className="footer-name">{PERSONAL.name}</p>
        <div className="footer-links">
          <a href={`mailto:${PERSONAL.email}`}>{PERSONAL.email}</a>
          <span>·</span>
          <a href={PERSONAL.linkedin} target="_blank" rel="noopener noreferrer">LinkedIn</a>
          <span>·</span>
          <span>{PERSONAL.location}</span>
        </div>
        <div className="footer-cta">
          <a href="https://calendly.com/chris-kohlerholding/30min" target="_blank" rel="noopener noreferrer">
            {lang === "en" ? "Book a Call" : "Réserver un Appel"}
          </a>
        </div>
        <p className="footer-built">Built in Lomé</p>
      </div>
    </footer>
  );
}

export default function App() {
  useEffect(() => {
    window.scrollTo(0, 0);
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
  }, []);

  return (
    <LanguageProvider>
      <div style={{ background: COLORS.cream }}>
        <Hero />
        <ImpactNumbers />
        <WhatIDo />
        <StorySection />
        <AIChatSection />
        <AiAtScaleSection />
        <CapabilitiesSection />
        <FitSection />
        <Credentials />
        <Footer />
      </div>
    </LanguageProvider>
  );
}
